import axios from 'axios';

export const getSitemapBySlugService = async (tenantId: string, slug: string) => {
    return await axios.get(`/tenant/${tenantId}/sitemap/${slug}/guest`);
}